import { InputBase, InputBaseProps } from '@mui/material';

/**
 * InputBase с безопасным onBlur
 * @param root0 - пропсы
 * @param root0.onBlur - обработчик onBlur
 */
export const BlurGuardInputBase = ({ onBlur, ...props }: InputBaseProps) => {
  return (
    <InputBase
      onBlur={event => {
        if (event) onBlur?.(event);
      }}
      {...props}
    />
  );
};
